// Canonical icon per entity — single source of truth.
// Used by the navigation bar, the detail-view identity badges and the
// overview-list identity cells so an entity's icon is defined in exactly
// one place.
export const ENTITY_ICONS = {
  employee: "mdi-briefcase-account",
  category: "mdi-shape",
  material: "mdi-screw-machine-flat-top",
  machine: "mdi-bulldozer",
  additionaleffort: "mdi-layers-plus",
  customer: "mdi-domain",
  project: "mdi-briefcase",
  userposition: "mdi-account-supervisor-circle",
  packet: "mdi-package-variant-closed",
  personnelplanning: "mdi-calendar-account",
  timetracking: "mdi-timer-play",
  // The two report types look alike everywhere else (same numbering, same columns, same calendar),
  // so their icons must not: a daily log book against a clipboard with a clock.
  constructionreport: "mdi-notebook-outline",
  hourlywagereport: "mdi-clipboard-text-clock-outline",
  // A day sent from the phone, which becomes one of the two above.
  daysubmission: "mdi-cellphone-arrow-down",
}
